import React, { useEffect, useState } from "react";
import { Spinner, Alert } from "react-bootstrap";
import { FaVideo } from "react-icons/fa";
import axios from "axios";
import API_ROUTE from "../../utils/apiRoute";

// Zoom's start_url embeds a short-lived ZAK token, so links emailed at
// booking time go stale by the time the meeting actually happens. This page
// is what those emails point to instead: it fetches a fresh start_url on
// load and redirects immediately, so the host link always works regardless
// of how long ago the reservation was made.
const ZoomStartPage = ({ match }) => {
  const [error, setError] = useState(null);
  const { reservId } = match.params;

  useEffect(() => {
    let didCancel = false;

    const redirectToStartUrl = async () => {
      try {
        const res = await axios.get(
          `${API_ROUTE}reservation/zoom-start-url/${reservId}`,
          { withCredentials: true }
        );
        const freshUrl = res.data?.data?.startUrl;
        if (didCancel) return;
        if (freshUrl) {
          window.location.replace(freshUrl);
        } else {
          setError("Não foi possível obter o link da reunião.");
        }
      } catch (err) {
        if (didCancel) return;
        setError(
          err?.response?.data?.message ||
            "Não foi possível iniciar a reunião. Verifique se ainda tem permissão para aceder a esta sessão Zoom."
        );
      }
    };

    redirectToStartUrl();

    return () => {
      didCancel = true;
    };
  }, [reservId]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <FaVideo size={40} color="#2D8CFF" style={{ marginBottom: "1rem" }} />
      {error ? (
        <Alert variant="danger" style={{ maxWidth: "480px" }}>
          {error}
        </Alert>
      ) : (
        <>
          <Spinner animation="border" variant="primary" style={{ marginBottom: "1rem" }} />
          <p>A iniciar a sua reunião Zoom...</p>
        </>
      )}
    </div>
  );
};

export default ZoomStartPage;
